import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum CallStatusIds {
  OPEN = 1,
  CLOSED = 2,
}

export function getCallStatii(): ISelectItem[] {
  return [
    { id: CallStatusIds.OPEN, label: 'Open' },
    { id: CallStatusIds.CLOSED, label: 'Closed' },
  ]
}

export const getCallStatusByLabel = getItemByLabelFactory(getCallStatii)
export const getCallStatusById = getItemByIdFactory(getCallStatii)
